export default __webpack_public_path__ + "c822a7402a422079a0c1bb6b07d97d0e.png";